import { render, staticRenderFns } from "./ESnippetMatricula.vue?vue&type=template&id=5af9f6ea"
import script from "./ESnippetMatricula.vue?vue&type=script&lang=js"
export * from "./ESnippetMatricula.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports